module.exports = __webpack_public_path__ + "media/images/plans/propose_original/propose-original-og-image-6686acc9b3d19aec7f0c689cd4d8232e.jpg";